import { Box } from "@chakra-ui/react";
import BaseLayout from "../../components/base_layout";
import Link from "next/link";
import { useRouter } from "next/router";

export default function SellerExplain() {
  const router = useRouter();

  const moveMarketPlace = async () => {
    router.push("/marketplace/market");
    return;
  };

  return (
    <BaseLayout>
      <Box className="seller_event_wrap">
        <Box className="seller_event_banner_wrap">
          <Box className="seller_event_banner"></Box>
        </Box>
        <Box className="seller_event_title">
          <h1>판매자를 위한 가이드</h1>
          <p>
            * 마켓플레이스는 판매자와 구매자, 모두가 신뢰를 바탕으로 함께
            성장하는 비즈니스 환경을 만들어 갑니다.
          </p>
        </Box>
        <Box className="seller_event_explain">
          <Box className="seller_explain_section">
            <h3>판매자 등록하기</h3>
            <p>* 회원가입 후 마이페이지에서 신청하세요.</p>
          </Box>
          <Box className="seller_explain_section">
            <h3>판매자 인증하기</h3>
            <p>* 판매자 등록 신청 후 24시간 내 인증이 완료합니다.</p>
          </Box>
          <Box className="seller_explain_section">
            <h3>재고 데이터 등록하기</h3>
            <p>* 판매자 대시보드에서 재고 데이터를 등록해 주세요.</p>
          </Box>
          <Box className="seller_explain_section">
            <h3>재고 데이터 인증하기</h3>
            <p>* 재고 데이터 등록 신청 후 24시간 내 인증이 완료됩니다.</p>
            <p>* 인증이 완료된 재고 데이터는 마켓플레이스에서 서비스됩니다.</p>
          </Box>
          <Box
            className="seller_explain_section"
            style={{
              borderBottom: "none",
            }}
          >
            <h3>판매자 대시보드 견적하기</h3>
            <p>* 구매자의 RFQ에 알림을 받은 후 견적정보를 입력하세요.</p>
            <p>* 견적 회신하기를 클릭해 주세요.</p>
          </Box>
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              moveMarketPlace();
            }}
            style={{
              textAlign: "center",
            }}
            className="goto_marketplacestore"
          >
            탐색하기
          </a>
        </Box>
      </Box>
    </BaseLayout>
  );
}
